import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

export const TableBody = ({ ...props }) => {
  const children = props.children
  return (
    <div>
      {React.Children.map(children, (child, i) => {
        if (i % 2 === 0) {
          return React.cloneElement(child, { even: true })
        } else {
          return React.cloneElement(child, { even: false })
        }
      })}
    </div>
  )
}

export const TableContainer = ({ children }) => (
  <StyledTableContainer>{children}</StyledTableContainer>
)

export const TableHeader = ({ children, loading }) => (
  <StyledTableHeader>
    {React.Children.map(children, (child, i) => {
      if (i === 0) {
        return React.cloneElement(child, { first: true, last: false, loading })
      } else if (i === children.length - 1) {
        return React.cloneElement(child, { first: false, last: true, loading })
      } else {
        return React.cloneElement(child, { first: false, last: false, loading })
      }
    })}
  </StyledTableHeader>
)

export const TableHeaderCell = ({ first, last, loading, children }) => (
  <Cell first={first} last={last} loading={loading}>
    {children}
  </Cell>
)

export const TableRow = ({ loading, even, children }) => {
  return (
    <StyledTableRow even={even}>
      {React.Children.map(children, (child, i) => {
        if (i === 0) {
          return React.cloneElement(child, {
            first: true,
            last: false,
            loading,
          })
        } else if (i === children.length - 1) {
          return React.cloneElement(child, {
            first: false,
            last: true,
            loading,
          })
        } else {
          return React.cloneElement(child, {
            first: false,
            last: false,
            loading,
          })
        }
      })}
    </StyledTableRow>
  )
}

export const TableRowCell = ({ first, last, loading, children }) => (
  <Cell first={first} last={last} loading={loading}>
    {children}
  </Cell>
)

const StyledTableContainer = glamorous.div({
  width: "100%",
  overflow: "scroll",
})

const StyledTableHeader = glamorous.div(
  {
    display: "flex",
    borderBottom: `1px solid ${style.colors.silverGray}`,
    paddingLeft: "0.5rem",
    [style.size.mobile]: {
      display: "none",
    },
  },
  ({ loading }) => ({
    filter: loading && "blur(5px)",
  })
)

const StyledTableRow = glamorous.div(
  {
    display: "flex",
    width: "100%",
    paddingLeft: "0.5rem",
    borderTop: `1px solid ${style.colors.silverGray}`,
    [style.size.mobile]: {
      flexDirection: "column",
      alignItems: "center",
      paddingLeft: 0,
    },
  },
  ({ even }) => ({
    backgroundColor: even ? style.colors.almostWhite : "white",
  })
)

const Cell = glamorous.div(
  {
    display: "flex",
    margin: "1rem",
    width: "25%",
    [style.size.mobile]: {
      marginLeft: 0,
      marginRight: 0,
      width: "90%",
      justifyContent: "center",
    },
  },
  ({ loading, first, last }) => ({
    filter: loading && "blur(5px)",
    marginLeft: first && 0,
    marginRight: last && 0,
  })
)



// WEBPACK FOOTER //
// ./src/containers/Table/index.js